import React from "react"

import Warehouse from "components/Tvendo/Article/DataMaster/Warehouse/List.js"

export default function () {

  return (
    <Warehouse></Warehouse>
  )
}